import { ProductAtPharmacyPoint } from './page/product/productAtPharmacyPoint'
import { getTooltipDataFromCms } from './utils/getCmsBlocks'
require('default-passive-events')
require('./vendor/magento/cookies.js')
require('./vendor/magento/gtm.js')
require('./vendor/aoe_static.js')
